/**
 * Wrapper accesible para screens completas en estado de carga.
 * Anuncia el estado a screen readers sin spamearlos con cada skeleton individual.
 */
const SkeletonScreen = ({ children, label = 'Cargando contenido...' }) => {
  return (
    <div role="status" aria-busy="true" aria-live="polite">
      <span className="sr-only">{label}</span>
      {children}
    </div>
  );
};

export default SkeletonScreen;